import Vuex from "vuex";
import Vue from "vue";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import images from "./modules/images";
import overlays from "./modules/overlays";
import showsJson from "./modules/showsJson";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    images: images,
    overlays: overlays,
    showsJson: showsJson
  },
  state: {
    shows: [],
    showsLoaded: false,
    audioEndpoint: "https://cdn3.soundslides.com/audio",
    imageEndpoint: "https://cdn3.soundslides.com/images",
    imageSizes: [400, 800, 1600], // Being generated by Lambda.
    jsonEndpoint: "https://cdn3.soundslides.com/json",
    imageMetadataItems: [],
    user: null,
    user_prefs: {},
    editor_shows: [],
    userAuthInitialized: false,
    currentShowDetails: null,
    currentShowId: null,
    currentShowHistory: [],
    currentSlideIndex: 0,
    currentShowRedoHistory: [],
    groupedSlideIds: [],
    historyUndoLevel: 0,
    historyAction: false,
    lastEditWasARedo: false,
    editorAudioReference: null,
    editVersionCount: 0, // Used to trigger player redraw during editing.
    bowser: null,
    initialSignupEmailPreference: true,
    pendingSave: false,
    pin_icon_name: "map-pin", //map-pin , thumbtack
    group_selected_icon_name: "check-circle",
    overlay_font_options: ["Lato", "Lora", "Allura", "Rancho", "Roboto"],
    layoutFunctions: ["threePanelOverlaySpace", "threePanelDefault"], // "twoPanelDefault" is not up to date!
    layoutIndex: 0,
    activePropertyItem: { type: "", value: {} },
    videoExportOnly: false,
    disableSaving: false,
    edit_pane_modes: [
      {
        name: "Library",
        id: "library",
        shortkey: ["1"]
      },
      {
        name: "Grid",
        id: "grid",
        shortkey: ["2"]
      },
      {
        name: "Overlays",
        id: "overlays",
        shortkey: ["3"]
      }
    ],
    edit_pane_mode: ["grid"],
    property_modes: [
      {
        name: "Project",
        id: "project",
        shortkey: ["5"]
      },
      {
        name: "Item",
        id: "item",
        shortkey: ["6"]
      }
    ],
    property_mode: []
  },
  actions,
  getters,
  mutations
});
